module.exports = __webpack_public_path__ + "img/energy_5.8ccdfb13.png";